import { getAnonymousId } from '@helpers/cookie';
import posthog from 'posthog-js';

let isPostHogInitialized = false;

export const usePostHog = () => {
  if (import.meta.env.VITE_POSTHOG_API_KEY && !isPostHogInitialized) {
    const anonymousId = getAnonymousId();
    posthog.init(import.meta.env.VITE_POSTHOG_API_KEY, {
      api_host: 'https://us.i.posthog.com',
      defaults: '2026-01-30',
      autocapture: false,
      capture_pageview: false,
      ...(anonymousId?.trim() && {
        bootstrap: {
          distinctID: anonymousId,
          isIdentifiedID: false,
        },
      }),
    });
    isPostHogInitialized = true;
  }

  return { posthog };
};
